module.exports = __webpack_public_path__ + "static/media/CheckCircle.52743ff9.svg";